<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title"> {{ $t('ds_institute_management.transportation_management') }} {{ $t('globalTrans.report') }}</h4>
      </template>
      <template v-slot:body>
            <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-row>
                        <b-col lg="6" sm="12" md="4">
                            <ValidationProvider name="Year" vid="year_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="year_id "
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('globalTrans.year')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.year"
                                    id="year_id"
                                    :options="yearList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Organization" vid="org_name_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="organiation_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.org_id"
                                    :options="orgList"
                                    id="organiation_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Type" vid="inst_type_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="inst_type_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.office_type_id"
                                    :options="officeTypeList"
                                    id="inst_type_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Name" vid="inst_name_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="inst_name_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.office_id"
                                    :options="officeList"
                                    id="inst_name_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <!-- <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="3"
                                  label-for="transport_name"
                              >
                              <template v-slot:label>
                                  {{$t('ds_institute_management.transport_name')}}
                              </template>
                              <b-form-select
                                  plain
                                  v-model="search.transport_name"
                                  id="transportation_id"
                                  :options="getTransportList"
                              >
                                  <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                              </b-form-select>
                              </b-form-group>
                          </b-col>
                          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                              <b-form-group
                                  class="row"
                                  label-cols-sm="3"
                                  label-for="transport_number"
                              >
                              <template v-slot:label>
                                  {{$t('ds_institute_management.transport_number')}}
                              </template>
                              <b-form-input
                                  plain
                                  v-model="search.transport_number"
                                  id="transportation_id"
                              >
                                  <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                              </b-form-input>
                              </b-form-group>
                          </b-col> -->
                        <b-col lg="6" sm="12">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="from_date"
                          >
                            <template v-slot:label>
                              {{$t('sales_distribution_admin.from_date')}}
                            </template>
                            <flat-pickr class="form-control"
                              v-model="search.from_date"
                              id="from_date"
                              :placeholder="$t('globalTrans.select_date')"
                              ></flat-pickr>
                          </b-form-group>
                        </b-col>
                        <b-col lg="6" sm="12">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="to_date"
                          >
                            <template v-slot:label>
                              {{$t('sales_distribution_admin.to_date')}}
                            </template>
                            <flat-pickr class="form-control"
                              v-model="search.to_date"
                              id="to_date"
                              :placeholder="$t('globalTrans.select_date')"
                              ></flat-pickr>
                          </b-form-group>
                        </b-col>
                        <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                            <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-row v-if="loaded">
              <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
              </b-col>
              <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                <div class="titleDiv">
                  <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('ds_institute_management.transportation_management') + ' ' + $t('globalTrans.report') }}</span><br>
                </div>
              </b-col>
              <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                <b-button-group>
                  <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                </b-button-group>
              </b-col>
              <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                <b-row>
                  <b-col xs="12" sm="12" md="6" class="text-left">
                    <div v-if="search.org_id" class="text-dark"><b>{{ $t('globalTrans.organization') }} </b>: {{ orgName(search.org_id) }}</div>
                    <span v-if="search.office_type_id" class="text-center text-dark"><b>{{ $t('child_configuration.institute_type') }} </b>: {{ getOfficeTypeName(search.office_type_id) }}</span>
                    <div v-if="search.office_id" class="text-dark"><b>{{ $t('child_configuration.institute_name') }} </b>: {{ getInstituteName(search.office_id) }}</div>
                  </b-col>
                  <b-col xs="12" sm="12" md="6" class="text-right">
                    <span v-if="search.year" class="text-center text-dark"><b>{{ $t('globalTrans.year') }} </b>: {{ getYear(search.year) }}</span><br/>
                    <span v-if="search.from_date" class="text-center text-dark"><b>{{ $t('globalTrans.date') }} </b>: {{ $d(new Date(search.from_date)) }} </span> <span class="text-center text-dark" v-if="search.to_date"> -  {{ $d(new Date(search.to_date)) }} </span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="12" sm="12">
                <b-overlay :show="loadingState">
                  <b-table-simple bordered hover small caption-top responsive>
                    <b-thead class="bg-primary">
                      <b-tr class="bg-primary">
                        <th class="text-center">{{ $t('globalTrans.sl_no') }}</th>
                        <th class="text-center" scope="col">{{ $t('ds_institute_management.transport_name') }}</th>
                        <th class="text-center" scope="col">{{ $t('ds_institute_management.transport_number') }}</th>
                        <th class="text-center" scope="col">{{ $t('ds_institute_management.driver_name') }}</th>
                        <th class="text-center" scope="col">{{ $t('ds_institute_management.mobile_no') }}</th>
                      </b-tr>
                    </b-thead>
                    <b-tbody v-for="(item, index) in report_data" :key="index">
                      <tr v-for="(driverItem, driverIndex) in item.driver_details" :key="driverIndex">
                        <b-td :rowspan="item.driver_details.length" v-if="driverIndex === 0" class="text-center">{{ $n(index + 1) }}</b-td>
                        <b-td :rowspan="item.driver_details.length" v-if="driverIndex === 0" class="text-center">{{ $i18n.locale === 'bn' ? item.transport_name_bn : item.transport_name }}</b-td>
                        <b-td :rowspan="item.driver_details.length" v-if="driverIndex === 0" class="text-center">{{ item.transport_number }}</b-td>
                        <b-td class="text-center">
                          {{ $i18n.locale === 'bn' ? driverItem.driver_name_bn : driverItem.driver_name }}
                        </b-td>
                        <b-td class="text-center">
                          {{ driverItem.driver_mobile | mobileNumber }}
                        </b-td>
                      </tr>
                    </b-tbody>
                    <b-tr v-if="notFound">
                      <b-td colspan="7" align="center"> {{ (currentLocale == 'bn') ? 'তথ্য পাওয়া যায়নি' : 'Data not found' }} </b-td>
                    </b-tr>
                  </b-table-simple>
                </b-overlay>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { transportationReport } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf'
import ReportHeading from '@/Utils/report-head'

export default {
  mixins: [RouteBasedList],
  components: {
  },
  data () {
    return {
      search: {
        year: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        transport_name: 0,
        transport_number: '',
        from_date: '',
        to_date: ''
      },
      officeTypeList: [],
      officeList: [],
      report_data: [],
      loaded: false,
      notFound: true,
      reportHeadData: ''
    }
  },
  computed: {
    getTransportList: function () {
      return this.$store.state.DisabilitySchoolService.commonObj.transportNameList.map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    yearList: function () {
        return this.$store.state.DisabilitySchoolService.commonObj.yearList.map(item => {
            if (this.$i18n.locale === 'bn') {
                return { value: item, text: this.$n(item, { useGrouping: false }) }
            } else {
                return item
            }
        })
    },
    orgList: function () {
        const list = this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        return list.map(obj => {
            if (this.currentLocale === 'en') {
                return { value: obj.value, text: obj.text_en }
            } else {
                return { value: obj.value, text: obj.text_bn }
            }
        })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
      this.getOfficeTypeList()
    },
    'search.office_type_id': function (newVal, oldVal) {
      this.getOfficeList()
    },
    currentLocale: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.headerName()
        this.getOfficeTypeList()
        this.getOfficeList()
      }
    }
  },
  created () {
    this.search.org_id = this.$store.state.dataFilters.orgId
    this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
    this.search.office_id = this.$store.state.dataFilters.officeId
    // this.headerName()
  },
  mounted () {
  },
  methods: {
    searchData () {
      this.headerName()
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search)
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(disabilitySchoolServiceBaseUrl, transportationReport, params).then(response => {
          if (response.success) {
            if (response.data !== null) {
              this.report_data = response.data
              if (response.data.length > 0) {
                this.notFound = false
              } else {
                this.notFound = true
              }
              this.$store.dispatch('setList', response.data)
            } else {
              this.report_data = ''
              this.notFound = true
            }
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    async headerName () {
        const headdata = await ReportHeading.getReportHead(disabilitySchoolServiceBaseUrl, 'configuration/report-heading/detail', this.search.org_id)
        if (headdata.orgName) {
            this.reportHeadData = headdata
            this.loaded = true
        } else {
            this.reportHeadData = ''
            this.loaded = false
            this.$toast.error({
                title: this.$i18n.locale === 'en' ? 'Report head not found!' : 'রিপোর্ট হেড পাওয়া যায়নি!',
                message: '',
                color: '#D6E09B'
            })
        }
    },
    pdfExport () {
      const reportTitle = this.$t('ds_institute_management.transportation_management') + ' ' + this.$t('globalTrans.report')
      ExportPdf.exportPdfDetails(disabilitySchoolServiceBaseUrl, 'configuration/report-heading/detail', this.search.org_id, reportTitle, this.report_data, this, this.search)
    },
    getOfficeTypeList () {
        if (this.search.org_id) {
            this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id)
        }
    },
    getOfficeList () {
        if (this.search.office_type_id) {
            this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id)
        }
    },
    orgName (orgId) {
      const orgName = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId)
      if (this.$i18n.locale === 'bn') {
        return orgName.text_bn
      } else {
        return orgName.text_en
      }
    },
    getOfficeTypeName (typeId) {
      const TypeName = this.$store.state.commonObj.officeTypeList.find(item => item.value === typeId)
      if (this.$i18n.locale === 'bn') {
        return TypeName.text_bn
      } else {
        return TypeName.text
      }
    },
    getInstituteName (InstId) {
      const institute = this.$store.state.commonObj.officeList.find(institute => institute.value === InstId)
      if (this.$i18n.locale === 'bn') {
        return institute.text_bn
      } else {
        return institute.text_en
      }
    },
    getYear (year) {
      if (this.$i18n.locale === 'bn') {
        return this.$n(year, { useGrouping: false })
      } else {
        return year
      }
    }
  }
}
</script>
